export default function DashboardFileIcon() {
  return (
    <svg
      width="52"
      height="44"
      viewBox="0 0 52 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M45.6243 7.49011H32.4618C31.7627 7.49011 31.0805 7.20399 30.5939 6.7038L25.8189 1.81211C24.6947 0.661243 23.1264 0 21.5156 0L6.4213 0.00211946C3.1678 0.00211946 0.521973 2.64297 0.521973 5.88587V38.1162C0.521973 41.3612 3.16981 44 6.4213 44H45.6226C48.8761 44 51.522 41.3591 51.522 38.1162V13.3735C51.522 10.1286 48.8741 7.48973 45.6226 7.48973L45.6243 7.49011ZM48.1234 38.1183C48.1234 39.4938 47.0014 40.6108 45.6243 40.6108H6.42135C5.04216 40.6108 3.92224 39.4917 3.92224 38.1183V5.8857C3.92224 4.51015 5.04428 3.39319 6.42135 3.39319H21.5135C22.2127 3.39319 22.8948 3.67932 23.3814 4.1795L28.1564 9.07119C29.2806 10.2221 30.8489 10.8833 32.4597 10.8833H45.6222C47.0014 10.8833 48.1213 12.0024 48.1213 13.3758V38.1186L48.1234 38.1183Z"
        fill="white"
      />
      <path
        d="M27.4401 16.5712C26.7342 15.8096 25.3131 15.8096 24.6071 16.5712L19.9629 21.5873C19.2987 22.3042 19.3963 23.3785 20.1788 23.9869C20.9614 24.5953 22.1341 24.5059 22.7982 23.789L24.1659 22.3106V33.2982C24.1659 34.2384 24.9972 35 26.0236 35C27.05 35 27.8813 34.2384 27.8813 33.2982V22.3106L29.2491 23.789C29.616 24.1847 30.1408 24.3911 30.6656 24.3911C31.0905 24.3911 31.5178 24.2592 31.8661 23.9869C32.6486 23.3785 32.7439 22.3063 32.082 21.5873L27.4378 16.5712L27.4401 16.5712Z"
        fill="white"
      />
    </svg>
  );
}
